module.exports = __webpack_public_path__ + "img/00017.8068cf9b.webp";